<template>
	<div class="ecology">
		<div class="content">
			<div class="title">药销通全链路服务生态</div>
			<div class="list flex-row">
				<div class="item flex-column" v-for="(item, index) in list" :key="index">
					<div><img :src="item.imgUrl" alt="" /></div>
					<div>{{ item.title }}</div>
					<div class="flex-center flex-column">
						<div v-for="(i, index) in item.textList" :key="i">{{ i }}</div>
					</div>
				</div>
			</div>
			<div class="button" @click="toOpen"><el-button>免费获取专家1对1服务</el-button></div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		toOpen() {
			this.$router.push('/freeTrial');
		},
	},
	data() {
		return {
			list: [
				//步骤条数据
				{
					title: '咨询',
					imgUrl: require('@/assets/productAndservice/consult.png'),
					textList: ['推广模式转型', '财务费用规划', '全链税务筹划', '服务商合规规范', '三级四流五务方案']
				},
				{
					title: '软件',
					imgUrl: require('@/assets/productAndservice/software.png'),
					textList: ['营销精细管理云系统', ' 强化医患服务全功能', ' 三级服务真实电子化', ' 费用预算与结算管理', ' 满足自营与招商模式']
				},
				{
					title: '服务',
					imgUrl: require('@/assets/productAndservice/serve.png'),
					textList: ['新型营销模式策划', ' 合规系统应用服务', ' 药企合规转型培训', ' 代理商服务转型辅导', ' 平台经济下自然人服务']
				}
			]
		};
	}
};
</script>

<style lang="scss" scoped>
.steps {
	width: 100%;
	height: 500px;
	background-color: white;
}
.bottom {
	height: 80px;
}

.content::before {
	content: '';
	display: table;
}
.title {
	margin: 0 auto;
	text-align: center;
	height: 45px;
	text-align: center;
	font-size: 32px;
	font-weight: 600;
	color: #333333;
	line-height: 45px;
	margin-top: 89px;
	margin-bottom: 74px;
}
.list {
	width: 100%;
	justify-content: space-between;
}
.item {
	transition: all 0.3s;
	width: 378px;
	height: 450px;
	background: linear-gradient(180deg, #f5f7f8 0%, #fefeff 100%);
	box-shadow: 0px 5px 12px 0px rgba(212, 212, 212, 0.5);
	border-radius: 4px;
	border: 2px solid #ffffff;
	align-items: center;
	& > :first-child {
		width: 126px;
		height: 153px;
		margin-top: 32px;
		margin-bottom: 38px;
	}
	& > :nth-child(2) {
		font-size: 24px;
		font-weight: 600;
		color: #333333;
	}
	& > :nth-child(3) {
		margin-top: 16px;
		font-size: 18px;
		font-weight: 400;
		color: #666666;
		line-height: 28px;
	}
}
.item:hover {
	transform: scale(1.03);
}
.el-button {
	width: 199px;
	height: 44px;
	border-radius: 4px;
	margin: 0 auto;
}
.button {
	width: 199px;
	margin: 0 auto;
	margin-top: 89px;
}
.ecology {
	background: #ffffff;
	margin-top: 105px;
}
.content {
	margin: 0 auto;
	width: $global-content-width;
}
</style>
